import React from 'react';
const links: {
  label: string;
  href: string;
}[] = [{
  label: 'Soporte',
  href: '#'
}, {
  label: 'Términos y condiciones',
  href: '#'
}, {
  label: 'Política de privacidad',
  href: '#'
}, {
  label: 'Blog',
  href: '#'
}];
export function Footer() {
  return <footer className="defer-paint w-full border-t border-line bg-paper py-10" data-id="element-105" data-mp="32m1d94cmxar9">
      <div className="mx-auto max-w-5xl px-6 text-center" data-id="element-106" data-mp="36ppj9ilmbyae">
        <p className="font-display text-base font-bold uppercase tracking-[0.22em] text-ink" data-id="element-107" data-mp="3uesbtlhsjbjo">
          MEGAPACK <span className="text-green" data-id="element-108" data-mp="37o5kstgztcb">Educación Física 360</span>™
        </p>
        <p className="mt-3 font-sans text-xs text-muted" data-id="element-109" data-mp="3levhb38pzigp">
          El sistema #1 para docentes de EF en Hispanoamérica
        </p>

        <div className="mx-auto mt-6 h-px w-16 bg-green/40" aria-hidden="true" data-id="element-110" data-mp="3qc3zv4xs5oih" />

        <nav aria-label="Enlaces legales y de soporte" data-id="element-111" data-mp="29yxbd88u9cjp">
          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2" data-id="element-112" data-mp="2a1jkhcbdo041">
            {links.map(link => <li key={link.label} data-id="element-113" data-mp="3l9k292unj58j">
                <a href={link.href} className="font-sans text-xs text-muted underline-offset-4 transition-colors duration-150 ease-out hover:text-green-deep hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green" data-id="element-114" data-mp="3lalgfg6ys7uh">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </nav>

        <p className="mt-6 font-sans text-xs leading-relaxed text-muted" data-id="element-115" data-mp="82id3u6tecfd">
          © 2026 MEGAPACK Educación Física 360™ — Todos los derechos
          reservados.
        </p>
        <p className="mx-auto mt-2 max-w-xl font-sans text-[11px] leading-relaxed text-muted" data-id="element-116" data-mp="hstuaifiei47">
          Material digital para docentes de Educación Física. Los resultados
          dependen de cómo se aplique el sistema en cada clase.
        </p>
      </div>
    </footer>;
}